import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassRow } from '../../helpers';

type Props = {
	isDisabled: boolean;
};

const RequierementsSection: React.FC<Props> = ({ isDisabled }) => {
	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Requirements"
				tooltip="Compliance, financial, and safety requirements that must be met for the successful execution of this job record."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="requestMBEOrWBERequirementsNote"
						label="MBE/WBE Requirements"
						name={JobUpsertFM.getAttributeName('requestMBEOrWBERequirementsNote')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="requestBondRequirementsNote"
						label="Bond Requirements"
						name={JobUpsertFM.getAttributeName('requestBondRequirementsNote')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="requestHSERequirementsNote"
						label="HSE Requirements"
						name={JobUpsertFM.getAttributeName('requestHSERequirementsNote')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="retainage"
						label="Retainage"
						name={JobUpsertFM.getAttributeName('retainage')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="requestInsuranceRequirementsNote"
						label="Insurance Requirements"
						name={JobUpsertFM.getAttributeName('requestInsuranceRequirementsNote')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="requestLiquidatedDamagesNote"
						label="Liquidated Damages"
						name={JobUpsertFM.getAttributeName('requestLiquidatedDamagesNote')}
						placeholder="Enter Requirements"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(RequierementsSection);
